const SectionLabel = ({ children, action }) => (
  <div className="flex items-center justify-between mb-6">
    <h2 className="font-mono text-sm text-accent tracking-wide">~/{children}</h2>
    {action}
  </div>
);

export default SectionLabel;
